import {
  getOohStatusIcon,
  getOverviewIcon,
  getStatusIcon,
  MasteryStatus,
  OohStatus,
} from "@models";
import {
  Badge,
  HyphenIcon,
  OverflowText,
  TextTooltip,
} from "@transfr-inc/dashboard-components";

export const getStatusConfig = ({ status, masteryScore, overview = false }) => {
  const getIcon = overview ? getOverviewIcon : getStatusIcon;
  const config = {};
  switch (status) {
    case MasteryStatus.Mastered:
      config.classname = "mastered";
      if (overview) {
        config.text = "Mastered";
      } else if (masteryScore) {
        config.text = `${(masteryScore * 100).toFixed(0)}%`;
      }
      break;
    case MasteryStatus.Complete:
      config.classname = "mastered";
      config.text = "Complete";
      break;
    case MasteryStatus.Stuck:
      config.classname = "stuck";
      config.text = overview
        ? "Stuck"
        : masteryScore
        ? `${(masteryScore * 100).toFixed(0)}%`
        : undefined;
      break;
    case MasteryStatus.NeedsWork:
      config.classname = "needs-work";
      config.text = "Needs Work";
      break;
    case MasteryStatus.InProgress:
      config.classname = "in-progress";
      config.text = overview
        ? "In Progress"
        : masteryScore
        ? `${(masteryScore * 100).toFixed(0)}%`
        : "In Progress";
      break;
    case MasteryStatus.Exempt:
      config.classname = "exempt";
      if (overview) config.text = "Exempt";
      break;
    default:
      config.text = <HyphenIcon />;
  }
  config.icon = config.classname ? getIcon(status) : undefined;
  return config;
};

export const getStatusConfigOverview = (status) =>
  getStatusConfig({ status, overview: true });

export const getOohStatusConfig = (status, masteryScore) => {
  const config = {};
  switch (status) {
    case OohStatus.COMPLETED:
      config.classname = "passed";
      config.text = "Complete";
      break;
    case OohStatus.PASSED:
      config.classname = "passed";
      if (masteryScore) {
        config.text = `${(masteryScore * 100).toFixed(0)}%`;
      } else {
        config.text = "Pass";
      }
      break;
    case OohStatus.FAILED:
      config.classname = "failed";
      if (masteryScore) {
        config.text = `${(masteryScore * 100).toFixed(0)}%`;
      } else {
        config.text = "Fail";
      }
      break;
    default:
      config.text = <HyphenIcon />;
  }
  config.icon = config.classname ? getOohStatusIcon(status) : undefined;
  return config;
};

export const tableCellListBadgeContent = (data) => {
  if (data?.length > 0) {
    let cellText = data.length > 1 ? data.length : data[0];
    cellText = <OverflowText text={cellText}>{cellText}</OverflowText>;

    if (data.length > 1) {
      const tooltipText = data.join("<br />");
      return (
        <TextTooltip theme="text" text={tooltipText}>
          <Badge value={cellText} />
        </TextTooltip>
      );
    }

    return (
      <OverflowText text={cellText}>
        <Badge value={cellText} />
      </OverflowText>
    );
  }

  return <HyphenIcon />;
};
